import { Dialog } from 'primereact/dialog'
import React, { useContext, useState } from 'react'
import { InputReturnDialogProps } from '../../../types/inbound'
import { Dropdown } from 'primereact/dropdown'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import { CommonContext } from '../../common/context/commonContext'
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InputReturnDialog = (props: InputReturnDialogProps) => {
    const { $toast } = useContext(CommonContext)
    const { t } = useTranslation()

    const [data, setData] = useState({
        tkbckAbrgCd: '',
        tkbckPrcsnTxt: '',
    })

    const types = [
        {
            codeId: 'SP',
            codeNm: '유통기한 임박・초과',
        },
        {
            codeId: 'BK',
            codeNm: t(tokens.common.damaged_goods),
        },
        {
            codeId: 'BD',
            codeNm: t(tokens.common.defected_goods),
        },
    ]

    const onChangeData = (field: string, value: string) => {
        setData({
            ...data,
            [field]: value,
        })
    }

    const onClickData = () => {
        if (!data.tkbckAbrgCd) {
            $toast({ title: t(tokens.common.fail), text: `반품 사유는 필수입니다.`, icon: 'warn' })
            return
        }

        if (!data.tkbckPrcsnTxt) {
            $toast({ title: t(tokens.common.fail), text: `사유는 필수입니다.`, icon: 'warn' })
            return
        }

        props.onChange && props.onChange(data)
    }

    return (
        <Dialog visible={props.visible} onHide={() => props.onHide && props.onHide()} closable={false} contentClassName="pb-0">
            <div className="grid">
                <div className="col-12 flex">
                    <span className="rdms-text-primary font-bold required">반품 사유</span>
                </div>
                <div className="col-12 flex mt-1">
                    <Dropdown
                        value={data.tkbckAbrgCd}
                        className="flex w-full p-inputtext-lg text-sm"
                        panelClassName="p-inputtext-sm"
                        options={types}
                        optionValue="codeId"
                        optionLabel="codeNm"
                        onChange={(e) => onChangeData('tkbckAbrgCd', e.value)}
                        placeholder={t(tokens.common.select_reason_for_return)}
                    />
                </div>
                <div className="col-12 flex">
                    <span className="rdms-text-primary font-bold required">사유 상세</span>
                </div>
                <div className="col-12 flex text-primary font-bold pt-0">
                    <InputTextarea
                        value={data.tkbckPrcsnTxt}
                        className="w-full"
                        rows={5}
                        onChange={(e) => onChangeData('tkbckPrcsnTxt', e.currentTarget.value)}
                        placeholder={t(tokens.common.please_enter_detailed_reason_for_return)}
                    />
                </div>
                <div className="col-6 flex text-primary font-bold pt-0">
                    <Button
                        className="mt-1 w-full p-button-secondary"
                        label={t(tokens.common.close)}
                        size="large"
                        onClick={() => props.onHide && props.onHide()}
                    />
                </div>
                <div className="col-6 flex text-primary font-bold pt-0">
                    <Button
                        className="w-full p-button-success"
                        label={t(tokens.common.complete)}
                        size="large"
                        onClick={() => onClickData()}
                        disabled={isEmpty(data.tkbckAbrgCd) || isEmpty(data.tkbckPrcsnTxt)}
                    />
                </div>
            </div>
        </Dialog>
    )
}

export default InputReturnDialog
